// recon-equity-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'rce.cat.shareCapital': 'Aksjekapital',
  'rce.cat.cooperativeCapital': 'Felleseid andelskapital',
  'rce.cat.sharePremium': 'Overkurs',
  'rce.cat.otherPaidIn': 'Annen innskutt egenkapital',
  'rce.cat.funds': 'Fond',
  'rce.cat.otherEarned': 'Annen opptjent egenkapital',
  'rce.cat.dividendProvision': 'Avsatt utbytte ført mot egenkapital',
  'rce.cat.privateAccount': 'Privatkonto, uttak og innskudd',
  'rce.cat.uncoveredLoss': 'Udekket tap / negativ egenkapital',
  'rce.cat.otherEquity': 'Annen egenkapital',
  'rce.type.dividendProvision': 'Avsatt utbytte',
  'rce.type.profitAllocation': 'Resultatdisponering',
  'rce.type.yearEndEntry': 'Årsoppgjørspostering mot egenkapital',
  'rce.type.distribution': 'Utdeling til eier',
  'rce.type.ownerCurrentAccount': 'Transaksjon mot mellomregning med eier',
  'rce.type.receipt': 'Innbetaling ført mot egenkapital',
  'rce.type.payment': 'Utbetaling ført mot egenkapital',
  'rce.flag.noDecisionBasis': 'Beslutningsgrunnlag mangler',
  'rce.flag.dispositionUnverified': 'Vedtatt disponering kan ikke verifiseres',
  'rce.flag.calcDifference': 'Beregningsdifferanse',
  'rce.item.counterAccount': 'Motkonto {codes}',
  'rce.item.statementDiff': '{label} — beregnet utgående avviker fra bokført',
  'rce.item.accounts': 'Kontoer: {codes}',
  'rce.item.driftTitle': '{code} {name} — bevegelsen i hovedboken forklarer ikke saldoendringen',
  'rce.item.driftDetail': 'Saldobalansen og bilagene er uenige om bevegelsen på kontoen.',
  'rce.item.negativeTitle': 'Beregnet egenkapital er negativ',
  'rce.item.negativeDetail': 'Negativ egenkapital skal vurderes av styret og dokumenteres.',
  'rce.item.noShareCapitalTitle': 'Ingen bokført aksjekapital på egenkapitalkontoene',
  'rce.item.noShareCapitalDetail': 'Et aksjeselskap skal ha bokført aksjekapital.',
  'rce.item.noRegisterTitle': 'Aksjeeierboka er ikke registrert i Plumme',
  'rce.item.noRegisterDetail': 'Uten aksjeeierbok kan verken eierskap eller utdelinger kontrolleres mot eierne.',
  'rce.decision.recorded': 'Generalforsamling registrert i Plumme',
  'rce.decision.uploaded': 'Opplastet protokoll',
  'rce.disp.dividend': 'Ordinært utbytte',
  'rce.disp.transfer': 'Overført til annen egenkapital',
  'rce.disp.total': 'Sum disponert',
  'rce.src.ledger': 'Hovedbok og saldobalanse',
  'rce.src.protocol': 'Generalforsamlingens vedtak',
  'rce.src.register': 'Aksjeeierbok',
  'rce.src.annual': 'Forrige års godkjente årsregnskap',
  'rce.src.registry': 'Registrert aksjekapital og kapitalendringer (Foretaksregisteret)',
  'rce.src.forecast': 'Budsjett og likviditetsprognose',
  'rce.src.ledgerDetail': 'Egenkapitalkontoene med inngående saldo og bevegelsene hittil i år.',
  'rce.src.protocolMissing': 'Verken registrert generalforsamling eller opplastet protokoll for året.',
  'rce.src.registerDetail': '{count} aksjonærer med til sammen {shares} aksjer',
  'rce.src.registerMissing': 'Ingen aksjonærer er registrert i Plumme.',
  'rce.src.articlesMissing': 'Vedtektene er ikke lastet opp på området.',
  'rce.src.annualMissing': 'Fjorårets resultat kunne ikke leses.',
  'rce.src.annualDetail': 'Årsresultat {year}: {result} kr',
  'rce.src.registryDetail': 'Plumme henter ikke registrert aksjekapital eller kapitalendringer. Kontrolleres manuelt mot registeret.',
  'rce.src.forecastDetail': 'Budsjett finnes for året. Egen likviditetsprognose hentes ikke av appen.',
  'rce.src.forecastMissing': 'Verken budsjett eller likviditetsprognose er tilgjengelig for året.',
  'rce.check.rollforward': 'Inngående egenkapital pluss bevegelser er lik utgående',
  'rce.check.vouchers': 'Bevegelsene har dekning i bilagene',
  'rce.check.decision': 'Utdelinger har dokumentert beslutningsgrunnlag',
  'rce.check.allocation': 'Bokført disponering summerer seg til forrige års resultat',
  'rce.check.direct': 'Direkteføringer mot egenkapital er identifisert',
  'rce.check.owners': 'Transaksjoner med eiere er identifisert',
  'rce.check.capital': 'Selskapsformens kapitalkrav er bokført',
  'rce.check.weak': 'Signaler om svak eller negativ egenkapital',
});
